import React, { Fragment } from 'react';
import { Row, Col, FormGroup, Form, Alert } from 'react-bootstrap';
import Select from 'react-select';
import LabelTitle from '../Label/labelTitle';
import LabelChargeData from '../Label/labelChargeData';
import language from '../../config/es';
import { wrapField } from './crudHelpers';

// Aviso de campos obligatorios
export const RequiredFieldsAlert = ({
  symbol = language.messages.labelSymbol,
  text = language.messages.labelSymbolRequired,
  className = 'alert-primary',
  textClassName = 'small',
}) => (
  <Alert className={className}>
    <strong className="text-danger small">{symbol}</strong>
    <span className={textClassName}> {text}</span>
  </Alert>
);

// Variante con las etiquetas lblSimbolo / lblfieldsRequired
export const RequiredFieldsAlertLegacy = () => (
  <RequiredFieldsAlert
    symbol={language.messages.lblSimbolo}
    text={language.messages.lblfieldsRequired}
    className="alert-primary "
  />
);

const ErrorText = ({ as = 'span', children }) =>
  as === 'div' ? (
    <div className="small text-danger">{children}</div>
  ) : (
    <span className="small text-danger">{children}</span>
  );

// Campo de seleccion con titulo, indicador de carga y mensajes de error
export const SelectField = ({
  label,
  required = true,
  loading,
  inlineLoading = false,
  name,
  options,
  field = {},
  value = { value: field.value, label: field.label },
  error = field.error,
  auth = field.auth,
  showAuth = false,
  errorPosition = 'inside',
  onChange,
  changeKey,
  isDisabled,
  className = 'text-uppercase small',
  col,
  row = false,
}) => {
  const title = <LabelTitle text={label} requerid={required} />;
  const header = inlineLoading ? (
    <Row>
      <Col md={12}>
        {title}
        <LabelChargeData showloading={loading} />
      </Col>
    </Row>
  ) : (
    <Row>
      <Col md={12}>{title}</Col>

      <LabelChargeData showloading={loading} />
    </Row>
  );
  return wrapField(
    <Fragment>
      {header}
      <FormGroup>
        <Select classNamePrefix="ui-select"
          isDisabled={isDisabled}
          placeholder={language.messages.lblSingleSelect}
          name={name}
          options={options}
          className={className}
          value={value}
          onChange={(selected) => {
            onChange(selected, changeKey);
          }}
        />
        {errorPosition === 'inside' && <ErrorText>{error}</ErrorText>}
        {showAuth && <ErrorText as="div">{auth}</ErrorText>}
      </FormGroup>
      {errorPosition === 'after' && <ErrorText>{error}</ErrorText>}
      {errorPosition === 'afterDiv' && <ErrorText as="div">{error}</ErrorText>}
    </Fragment>,
    col,
    row
  );
};

// Campo de texto con titulo y mensaje de error
export const TextField = ({
  label,
  required = true,
  name,
  field,
  onChange,
  compact = true,
  col,
  row = false,
  ...controlProps
}) =>
  wrapField(
    <FormGroup>
      <LabelTitle text={label} requerid={required} />
      <Form.Control
        size={compact ? 'sm' : undefined}
        type="text"
        name={name}
        id={name}
        value={field.value}
        onChange={onChange}
        {...controlProps}
      />
      <ErrorText>{field.error}</ErrorText>
    </FormGroup>,
    col,
    row
  );

// Seleccion de pais comun a las vistas por pais / entidad
export const CountrySelect = ({ data, onChange, className, col }) => (
  <SelectField
    row
    col={col}
    label={language.messages.labelCountry}
    loading={data.showloadingCountry}
    isDisabled={data.id !== null}
    name="country"
    options={data.countries}
    className={className}
    field={data.country}
    showAuth
    onChange={onChange}
    changeKey="country"
  />
);
